import styled, { css } from 'styled-components';
import Minus from '@widgets/shared/components/icons/Minus';
import Plus from '@widgets/shared/components/icons/Plus';
export const Label = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
`;
const Icon = css `
  height: 3.2rem;
  width: 3.2rem;
  cursor: pointer;
`;
export const ButtonMinus = styled(Minus) `
  ${Icon}
`;
export const ButtonPlus = styled(Plus) `
  ${Icon}
`;
export const Element = styled.button `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  border: none;
  padding: 0;
  line-height: 0;
  
  &:disabled {
    opacity: .4;
  }
`;
export default {
    Element,
    Label,
    Icon,
    Minus: ButtonMinus,
    Plus: ButtonPlus,
};
